import React from 'react';

const SplitHeading = ({ text }) => {
	return <div className="split-heading">{text}</div>;
};

export default SplitHeading;
